import { ROUTE_ACTIONS } from '../../actions/routes';

const initialState = {
  routes: [],
  route: undefined,
  contentType: undefined,
  params: undefined,
  screenDesignerParams: undefined,
  customRouteParams: undefined,
  tabIndex: 0,
  screenIndex: 0,
  childRoutes: [],
  parentRoutes: []
};

const RouteReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case ROUTE_ACTIONS.ROUTE_CHANGED:
      const params = {
        ...action.payload.params,
        ...state.screenDesignerParams
      };
      return {
        ...state,
        ...action.payload,
        params
      };
    case ROUTE_ACTIONS.ROUTES_LOADED: {
      return {
        ...state,
        routes: action.payload
      };
    }
    case ROUTE_ACTIONS.ADD_SCREEN_DESIGNER_ROUTE_PARAMS: {
      return {
        ...state,
        screenDesignerParams: action.payload,
        params: {
          ...state.params,
          ...action.payload
        }
      };
    }
    case ROUTE_ACTIONS.ADD_CUSTOM_ROUTE_PARAMS: {
      return {
        ...state,
        customRouteParams: action.payload,
        params: {
          ...state.params,
          ...action.payload
        }
      };
    }
    case ROUTE_ACTIONS.CLEAR_SCREEN_DESIGNER_ROUTE_PARAMS: {
      const newParams = { ...state.params };
      if (state.screenDesignerParams) {
        Object.keys(state.screenDesignerParams).forEach(key => {
          delete newParams[key];
        });
      }

      return {
        ...state,
        screenDesignerParams: undefined,
        params: newParams
      };
    }

    case ROUTE_ACTIONS.CLEAR_CUSTOM_ROUTE_PARAMS: {
      const newParams = { ...state.params };
      if (state.customRouteParams) {
        Object.keys(state.customRouteParams).forEach(key => {
          delete newParams[key];
        });
      }

      return {
        ...state,
        customRouteParams: undefined,
        params: newParams
      };
    }
    default:
      return state;
  }
};

export default RouteReducer;
